// Do not modify this file by hand!
// Re-generate this file by running lit-localize
import { str } from '@lit/localize';
/* eslint-disable no-irregular-whitespace */
/* eslint-disable @typescript-eslint/no-explicit-any */
export const templates = {
    'button.default': `Bouton`,
    'card.action.delete': `Supprimer`,
    'card.action.logs': `Journaux`,
    'card.action.run': `Exécuter`,
    'card.action.runWorkflow': `Exécuter le workflow`,
    'card.action.settings': `Paramètres`,
    'card.icon.alt': `Icône`,
    'card.nodeIcon': `Icône du nœud`,
    'card.visibility.hide': `Masquer de la carte`,
    'card.visibility.show': `Afficher sur la carte`,
    'changeCard.action.delete.title': `Supprimer`,
    'changeCard.type.add': `Ajouter`,
    'changeCard.type.delete': `Supprimer`,
    'changeCard.type.edit': `Modifier`,
    'common.action.add': `Ajouter`,
    'common.action.back': `Retour`,
    'common.action.cancel': `Annuler`,
    'common.action.close': `Fermer`,
    'common.action.confirm': `Confirmer`,
    'common.action.delete': `Supprimer`,
    'common.action.edit': `Modifier`,
    'common.action.export': `Exporter`,
    'common.action.import': `Importer`,
    'common.action.next': `Suivant`,
    'common.action.previous': `Précédent`,
    'common.action.refresh': `Rafraîchir`,
    'common.action.remove': `Retirer`,
    'common.action.removeItem': str `Retirer ${0}`,
    'common.action.save': `Enregistrer`,
    'common.action.search': `Rechercher`,
    'common.action.validate': `Valider`,
    'common.message.noData': `Aucune donnée disponible`,
    'common.message.noDescription': `Aucune description disponible`,
    'common.message.noNetwork': `Aucun réseau sélectionné`,
    'common.message.noPoi': `Aucun POI disponible`,
    'common.message.noResults': `Aucun résultat trouvé`,
    'common.state.active': `Actif`,
    'common.state.error': `Erreur`,
    'common.state.inactive': `Inactif`,
    'common.state.loading': `Chargement...`,
    'common.state.success': `Succès`,
    'common.state.warning': `Attention`,
    'compare.columns.added': `Colonnes ajoutées`,
    'compare.columns.modified': `Colonnes modifiées`,
    'compare.columns.removed': `Colonnes supprimées`,
    'compare.columns.unchanged': `Colonnes inchangées`,
    'compare.detail.andMore': str `, et ${0} de plus.`,
    'compare.detail.noChange': `Aucune modification.`,
    'compare.error.missingDataFrames': `Veuillez fournir les deux DataFrames à comparer.`,
    'compare.error.noIndexColumn': `Les deux DataFrames doivent avoir une colonne d'index pour la comparaison.`,
    'compare.error.unavailable': `La comparaison est en cours ou indisponible.`,
    'compare.merge.addOnly': `Ajouter uniquement`,
    'compare.merge.replace': `Remplacer`,
    'compare.merge.update': `Mettre à jour`,
    'compare.mergeMethod': `Méthode de fusion`,
    'compare.resume.add': str `Vous allez ajouter ${0} ${1}.`,
    'compare.resume.replace': str `Vous allez remplacer les ${0} ${1} existantes par ${2} nouvelles ${3}, et remplacer les ${4} ${5} existantes par ${6} nouvelles ${7}.`,
    'compare.resume.update': str `Vous allez ajouter ${0} ${1}, mettre à jour ${2} ${3}, retirer ${4} ${5}, ajouter ${6} ${7}, modifier ${8} ${9} et retirer ${10} ${11}.`,
    'compare.rows.added': `Lignes ajoutées`,
    'compare.rows.modified': `Lignes modifiées`,
    'compare.rows.removed': `Lignes supprimées`,
    'compare.rows.unchanged': `Lignes inchangées`,
    'compare.title': `Comparaison de DataFrame`,
    'compare.vocab.column': `colonne`,
    'compare.vocab.columns': `colonnes`,
    'compare.vocab.dataframe': `DataFrame`,
    'compare.vocab.dataframes': `DataFrames`,
    'compare.vocab.row': `ligne`,
    'compare.vocab.rows': `lignes`,
    'component.action.add': `Ajouter`,
    'componentList.loading': `Chargement des composants…`,
    'error.network.fileRequired': `Le fichier du réseau est requis`,
    'error.network.idRequired': `Un identifiant unique est requis pour le réseau`,
    'error.network.idRequiredUpdate': `Un identifiant unique est requis pour mettre à jour le réseau`,
    'error.network.importFileRequired': `Un fichier d'importation est requis`,
    'error.network.nameAndTypeRequired': `Le nom et le type du réseau sont requis`,
    'field.manager.alias': `Alias`,
    'field.manager.columnName': `Nom de la colonne`,
    'field.manager.type': `Type`,
    'field.type.boolean': `Booléen`,
    'field.type.date': `Date`,
    'field.type.ignore': `Ignorer`,
    'field.type.number': `Nombre`,
    'field.type.text': `Texte`,
    'fileTable.error.legacyXls': `Les anciens fichiers .xls ne sont pas pris en charge. Ouvrez le fichier dans Excel, enregistrez-le au format .xlsx, puis relancez l'import.`,
    'fileTable.error.unreadable': str `Ce fichier n'a pas pu être lu : ${0}`,
    'fileTable.error.unsupportedType': str `Format de fichier non pris en charge (« .${0} »). Importez un fichier .csv ou .xlsx.`,
    'flow.loading.connecting': `Connexion à Flow…`,
    'flow.loading.phrase.analyzing': `Flow analyse…`,
    'flow.loading.phrase.calculating': `Flow calcule…`,
    'flow.loading.phrase.mapping': `Flow cartographie…`,
    'flow.loading.phrase.optimizing': `Flow optimise…`,
    'flow.loading.phrase.thinking': `Flow réfléchit…`,
    'flow.status.completed': `Terminé`,
    'flow.status.failed': `Échec`,
    'flow.status.pending': `En attente`,
    'flow.status.running': `En cours`,
    'form.advancedToggle': `Avancé`,
    'form.color.applyCustom': `Appliquer la couleur personnalisée`,
    'form.data': `Données du formulaire`,
    'form.file.choose': `Choisir un fichier`,
    'form.image.chooseImage': `Choisir une image`,
    'form.image.noImage': `Aucune image sélectionnée`,
    'form.image.preview': `Aperçu de l'image`,
    'form.json.invalid': `JSON non valide`,
    'form.json.placeholder': `Coller ou saisir le JSON ici…`,
    'form.label.address': `Adresse`,
    'form.label.description': `Description`,
    'form.label.email': `Email`,
    'form.label.file': `Fichier`,
    'form.label.name': `Nom`,
    'form.label.phone': `Téléphone`,
    'form.label.type': `Type`,
    'form.noConfiguration': `Aucune donnée de configuration disponible.`,
    'form.placeholder.date': `Date…`,
    'form.placeholder.enterName': `Entrez le nom`,
    'form.placeholder.enterNumber': `Entrez un nombre...`,
    'form.placeholder.numberInput': `Saisie d'un nombre…`,
    'form.placeholder.search': `Rechercher...`,
    'form.placeholder.selectOption': `Sélectionnez une option`,
    'form.placeholder.selectOptions': `Sélectionner des options…`,
    'form.placeholder.textArea': `Zone de texte…`,
    'form.placeholder.textInput': `Saisie de texte…`,
    'form.sql.placeholder': `Écrire le code SQL ici…`,
    'form.timeoutLabel': `Délai d'expiration (s)`,
    'geojsonMap.noProperties': `Aucune propriété`,
    'header.alt.galigeo': `Galigeo`,
    'header.alt.network': `Réseau`,
    'header.alt.user': `Utilisateur`,
    'header.organization': `organisation :`,
    'header.unknownOrg': `Inconnu`,
    'header.unknownUser': `Inconnu`,
    'iconButton.ariaLabel': `bouton d'icône`,
    'inputNode.header': `Données d'entrée`,
    'inputNode.noInputDataSelected': `Aucune donnée d'entrée sélectionnée.`,
    'jsonDisplayer.noData': `Aucune donnée disponible`,
    'kebab.ariaLabel': `Plus d'options`,
    'kpiDimensionCard.chart.placeholder': `Emplacement du graphique`,
    'map.loadingNetworks': `Chargement des réseaux…`,
    'map.locate.alt': `Me localiser`,
    'map.myLocation': `Ma position`,
    'map.noName': `Nom non disponible`,
    'map.search': `Rechercher`,
    'map.search.alt': `Rechercher`,
    'map.search.notFound': `Lieu introuvable`,
    'map.zoomIn': `Zoomer`,
    'map.zoomIn.alt': `Zoom avant`,
    'map.zoomOut': `Dézoomer`,
    'map.zoomOut.alt': `Zoom arrière`,
    'modal.close': `Fermer`,
    'modal.confirm.message': `Êtes-vous sûr de vouloir continuer ?`,
    'modal.confirm.placeholder': `Saisissez le texte ci-dessus`,
    'modal.confirm.prompt': `Pour confirmer, saisissez :`,
    'modal.confirm.title': `Confirmer l'opération`,
    'navRail.ariaLabel': `Catégories`,
    'network.config.instruction': `Configurer les paramètres réseau pour`,
    'network.create.instruction': `Entrez un nom, une description et un type de réseau pour le réseau`,
    'network.create.step1': `Informations du réseau`,
    'network.create.step2': `Importer un fichier`,
    'network.create.step3': `Configuration`,
    'network.create.title': `Créer un nouveau réseau`,
    'network.duplicate.includeData': `Inclure les données associées au réseau (Zones, Matrices de distance, ...)`,
    'network.duplicate.name': `Nom du réseau dupliqué :`,
    'network.edit.description': `Description (optionnel) :`,
    'network.edit.logo': `Logo (optionnel) :`,
    'network.edit.name': `Nom :`,
    'network.export.format': `Format d'exportation :`,
    'network.import.instruction': `Importer un fichier pour le réseau`,
    'network.import.supportedFormats': `Formats supportés : CSV et Excel.`,
    'network.info.createdBy': `Créé par`,
    'network.info.lastModified': `Dernière modification le`,
    'network.info.on': `le`,
    'network.label.file': `Fichier du réseau`,
    'network.label.name': `Nom du réseau`,
    'network.label.type': `Type de réseau`,
    'network.placeholder.description': `Entrez une description pour le réseau`,
    'network.placeholder.duplicateName': `Entrez un nom pour le réseau dupliqué`,
    'network.placeholder.enterDescription': `Entrez une description`,
    'network.placeholder.enterName': `Entrez un nom`,
    'network.placeholder.name': `Entrez le nom du réseau`,
    'network.placeholder.selectType': `Sélectionnez le type de réseau`,
    'network.poi.addPoint': `Ajouter un point`,
    'network.poi.editPoint': `Modifier le point`,
    'network.toolbox.addNetwork': `+ Réseau`,
    'network.toolbox.copy': `Copier`,
    'network.update.step1': `Importer un fichier`,
    'network.update.step2': `Configuration`,
    'network.update.step3': `Options de mise à jour`,
    'network.update.summaryChoice': `et choix du type de mise à jour.`,
    'network.update.summaryInstruction': `Résumé de la mise à jour du réseau pour`,
    'network.update.title': `Mettre à jour le réseau`,
    'network.vocabulary.column': `attribut`,
    'network.vocabulary.columns': `attributs`,
    'network.vocabulary.dataframe': `Réseau`,
    'network.vocabulary.dataframes': `Réseaux`,
    'network.vocabulary.row': `point`,
    'network.vocabulary.rows': `points`,
    'nodeInput.action.addItem': `Ajouter un élément`,
    'nodeInput.action.addKeyValue': `Ajouter Clé/Valeur`,
    'nodeInput.label.checkbox': `Case à cocher`,
    'nodeInput.noDescription': `Aucune description disponible`,
    'nodeInput.noLabel': `Aucun libellé fourni`,
    'nodeInput.placeholder.enterText': `Saisir du texte`,
    'nodeInput.placeholder.key': `Clé`,
    'nodeInput.placeholder.keyNumber': `Clé (Nombre)`,
    'nodeInput.placeholder.value': `Valeur`,
    'nodeInput.preview': `Aperçu :`,
    'nodeInput.rawData': `Données brutes`,
    'notification.link.openMap': `Ouvrir la carte`,
    'notification.link.openModule': `Ouvrir le module`,
    'notification.link.openUrl': `Ouvrir le lien`,
    'notification.markAsRead': `Marquer comme lu`,
    'notification.marking': `Marquage…`,
    'notification.open': `Ouvrir`,
    'notification.popup.close': `Fermer`,
    'notification.preview.empty': `Aucune nouvelle notification`,
    'notification.preview.markAllRead': `Tout marquer comme lu`,
    'notification.preview.markingAll': `Marquage…`,
    'notification.preview.seeMore': `Voir plus`,
    'notification.preview.title': `Notifications`,
    'notification.time.justNow': `À l'instant`,
    'operationCard.impact.placeholder': `Impact prévisionnel sur le chiffre d'affaires : bientôt disponible`,
    'operationCard.menu.delete': `Supprimer`,
    'operationCard.menu.edit': `Modifier`,
    'operationCard.menu.title': `Options`,
    'operationCard.opType.add': `Ajouter`,
    'operationCard.opType.delete': `Retirer`,
    'operationCard.opType.edit': `Modifier`,
    'operationCard.opType.transfer': `Transfert`,
    'operationCard.props.label': `Propriétés`,
    'operationCard.transfer.ariaLabel': `Transfert entre deux réseaux`,
    'operationCard.transfer.from': `De`,
    'operationCard.transfer.to': `Vers`,
    'outputNode.header': `Données de sortie`,
    'outputNode.noExecutionData': `Aucune donnée d'exécution disponible. Lancez le workflow pour voir les données de sortie.`,
    'panel.close': `Fermer`,
    'poi.form.action.back': `Retour`,
    'poi.form.action.cancel': `Annuler`,
    'poi.form.action.next': `Suivant`,
    'poi.form.action.save': `Sauvegarder`,
    'poi.form.address': `Adresse`,
    'poi.form.city': `Ville`,
    'poi.form.description': `Description`,
    'poi.form.geocodeFound': str `Adresse trouvée : ${0}`,
    'poi.form.geocodeSearching': `Recherche de l'adresse…`,
    'poi.form.identityHint': `Renseigne soit l'adresse, soit les coordonnées (au moins l'un des deux).`,
    'poi.form.latitude': `Latitude`,
    'poi.form.locateAddress': `Localiser l'adresse`,
    'poi.form.longitude': `Longitude`,
    'poi.form.name': `Nom du POI`,
    'poi.form.openingDate': `Date d'ouverture`,
    'poi.form.postalCode': `Code postal`,
    'poi.form.resetPosition': `Réinitialiser la position`,
    'poi.form.step.identity': `Identité`,
    'poi.form.step.properties': `Propriétés`,
    'poi.form.uniqueId': `Identifiant unique`,
    'poi.popup.address': `Adresse`,
    'poi.popup.createdOn': `Créé le :`,
    'poi.popup.logoAlt': `Logo`,
    'poi.popup.updatedOn': `Mis à jour le :`,
    'poi.status.correct': `POI correctement géocodé`,
    'poi.status.lowAccuracy': `Précision de géocodage faible`,
    'poi.status.missingCoords': `Coordonnées manquantes ou incorrectes`,
    'poi.table.lowAccuracy': `POI avec précision de géocodage faible :`,
    'poi.table.missingCoords': `POI avec coordonnées manquantes ou incorrectes :`,
    'rightModalForm.close': `Fermer`,
    'rightModalForm.defaultTitle': `Formulaire`,
    's179813e8b043388a': `Données de sortie :`,
    's21cb2d37a35ab30b': str `${0} ${1}${2}`,
    's340f7fb59b4b3a52': `Terminé le :`,
    's382a2aa3984474dd': `Créer`,
    's4a51d83734ae7221': `Entrez le nom du workflow`,
    's4cafc334cb16b8af': `Commencé le :`,
    's5e8250fb85d64c23': `Fermer`,
    's63d894b1ddb06289': `Description`,
    's71c1869685b3881b': `Entrez une description`,
    'sa4c9cfbc556c7a7b': `Nom du workflow`,
    'sbdc6b9a8655e7e86': `Aucune donnée d'exécution disponible. Lancez le workflow pour voir les données d'entrée.`,
    'scef7dec2b70f247f': `Journal d'exécution`,
    'scenario.status.cancelled': `Annulé`,
    'scenario.status.draft': `Brouillon`,
    'scenario.status.inProgress': `En cours`,
    'scenario.status.validated': `Validé`,
    'scenarioCard.action.delete.aria': `Supprimer l'étude`,
    'scenarioCard.action.delete.title': `Supprimer`,
    'scenarioCard.action.share.aria': `Partager cette étude`,
    'scenarioCard.action.share.disabledTitle': `Le partage n'est pas encore disponible`,
    'scenarioCard.action.zoomTo.aria': `Centrer cette étude sur la carte`,
    'scenarioCard.action.zoomTo.title': `Centrer sur la carte`,
    'scenarioCard.ops.empty': `Aucune opération`,
    'scenarioCard.opType.add.plural': `Ajouts`,
    'scenarioCard.opType.add.singular': `Ajout`,
    'scenarioCard.opType.delete.plural': `Suppressions`,
    'scenarioCard.opType.delete.singular': `Suppression`,
    'scenarioCard.opType.modify.plural': `Modifications`,
    'scenarioCard.opType.modify.singular': `Modification`,
    'scenarioCard.opType.transfer.plural': `Transferts`,
    'scenarioCard.opType.transfer.singular': `Transfert`,
    'scenarioEditor.addPoi': `+ Ajouter un POI`,
    'scenarioEditor.deletePoi': `Supprimer le POI`,
    'scenarioEditor.editPoi': `Modifier le POI`,
    'scenarioEditor.transferPoi': `Transférer le POI`,
    'scenarioMap.layers': `Couches`,
    'scenarioMap.legend.add': `Ajouter`,
    'scenarioMap.legend.delete': `Supprimer`,
    'scenarioMap.legend.edit': `Modifier`,
    'scenarioMap.networks': `Réseaux`,
    'scenarioMap.noNetworks': `Aucun réseau`,
    'scenarioMap.role.attractor': `Attracteurs`,
    'scenarioMap.role.competitor': `Concurrents`,
    'scenarioMap.role.own': `Propre`,
    'scenarioOperation.action.delete.aria': `Supprimer l'opération`,
    'scenarioOperation.action.edit.aria': `Modifier l'opération`,
    'scenarioOperation.opType.add': `Ajouter`,
    'scenarioOperation.opType.delete': `Supprimer`,
    'scenarioOperation.opType.edit': `Modifier`,
    'scenarioOperation.opType.fallback': `Opération`,
    'scenarioOperation.opType.transfer': `Transfert`,
    'studyMap.exitFullscreen': `Quitter le plein écran`,
    'studyMap.fullscreen': `Carte en plein écran`,
    'studyMap.layer.attractors': `Attracteurs`,
    'studyMap.layer.competitors': `Concurrents`,
    'studyMap.layer.current': `Étude courante`,
    'studyMap.layer.others': `Autres études`,
    'studyMap.layers': `Couches`,
    'studyMap.overlay.computed': `Calculée`,
    'studyMap.overlay.intersected': `Intersectée`,
    'table.error.noData': `Aucune donnée dans ce tableau`,
    'table.error.noDataForNetwork': `Aucune donnée trouvée pour ce réseau`,
    'table.error.noDataFrame': `Aucun DataFrame fourni au tableau`,
    'table.pagination.next': `Suivant`,
    'table.pagination.page': `Page`,
    'table.pagination.previous': `Précédent`,
    'table.rowCount': `Nombre de lignes :`,
    'toggle.default': `Basculer`,
    'toggle.off': `Désactivé`,
    'toggle.on': `Activé`,
    'variable.action.addEngine': `Ajouter un moteur de workflow`,
    'variable.action.addGlobal': `Ajouter une variable globale`,
    'variable.action.addWorkflow': `Ajouter une variable de workflow`,
    'variable.title.engines': `Moteurs`,
    'variable.title.orgParams': `Paramètres d'organisation`,
    'variable.title.workflowVariables': `Variables de workflow`,
    'wfProperties.tab.engines': `Moteurs`,
    'wfProperties.tab.parameters': `Paramètres`,
    'wfProperties.tab.workflowVariables': `Variables de workflow`,
    'wfProperties.title.configuredEngines': `Moteurs configurés :`,
    'wfProperties.title.globalParams': `Paramètres globaux :`,
    'wfProperties.title.workflowVariables': `Variables de workflow :`,
    'workflow.card.createdBy': `Créé par :`,
    'workflow.card.editWorkflow': `Modifier le workflow`,
    'workflow.card.logs': `Journaux`,
    'workflow.create.title': `Créer un nouveau workflow`,
    'workflowExecutionCard.executionId': `ID d'exécution :`,
    'workflowExecutionCard.finished': `Terminé :`,
    'workflowExecutionCard.inProgress': `En cours`,
    'workflowExecutionCard.started': `Démarré :`,
    'workflowExecutionCard.unknownWorkflow': `Workflow inconnu`,
    'zoneCard.action.changeColor': `Changer la couleur`,
    'zoneCard.fallbackName': str `Zone n° ${0}`,
    'zoneCard.meta.parent': `parent`,
    'zoneCard.typeFallback': str `type ${0}`,
    'zoneList.empty.text': `Aucune zone à afficher.`,
    'zoneList.empty.title': `Aucune zone`,
    'zoneList.loading': `Chargement des zones…`,
};
//# sourceMappingURL=fr.js.map